import { render, staticRenderFns } from "./LinkIcon.vue?vue&type=template&id=684f69b6"
import script from "./LinkIcon.vue?vue&type=script&lang=js"
export * from "./LinkIcon.vue?vue&type=script&lang=js"
import style0 from "./LinkIcon.vue?vue&type=style&index=0&id=684f69b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports